import { __spreadArrays } from "tslib";
import { catmullRom2Bezier } from '@antv/path-util';
import { Category, Linear } from '@antv/scale';
import { each, head, isEqual, map } from '@antv/util';
/**
 * ç¹æ°ç»è½¬ path
 * @param points
 */
function pointsToPath(points) {
    return map(points, function (p, idx) {
        var command = idx === 0 ? 'M' : 'L';
        var x = p[0], y = p[1];
        return [command, x, y];
    });
}
/**
 * å°ç¹è¿æ¥æè·¯å¾ path
 * @param points
 */
export function getLinePath(points) {
    return pointsToPath(points);
}
/**
 * å°ç¹è¿æå¹³æ»çæ²çº¿
 * @param points
 */
export function getSmoothLinePath(points) {
    if (points.length <= 2) {
        // ä¸¤ç¹ä»¥åç´æ¥ç»å¶æè·¯å¾
        return getLinePath(points);
    }
    var data = [];
    each(points, function (p) {
        // å½åç¹åä¸ä¸ä¸ªç¹ä¸æ ·çæ¶åï¼å¿½ç¥æ
        if (!isEqual(p, data.slice(data.length - 2))) {
            data.push(p[0], p[1]);
        }
    });
    // const constraint = [ // èå´
    //   [ 0, 0 ],
    //   [ 1, 1 ],
    // ];
    var path = catmullRom2Bezier(data, false);
    var _a = head(points), x = _a[0], y = _a[1];
    path.unshift(['M', x, y]);
    return path;
}
/**
 * å°æ°æ®è½¬æ pathï¼å©ç¨ scale çå½ä¸åè½å
 * @param data
 * @param width
 * @param height
 * @param smooth
 */
export function dataToPath(data, width, height, smooth) {
    if (smooth === void 0) { smooth = true; }
    // å©ç¨ scale æ¥è·å y ä¸çæ å°
    var y = new Linear({
        values: data,
    });
    var x = new Category({
        values: map(data, function (v, idx) { return idx; }),
    });
    var points = map(data, function (v, idx) {
        return [x.scale(idx) * width, height - y.scale(v) * height];
    });
    return smooth ? getSmoothLinePath(points) : getLinePath(points);
}
/**
 * è·å¾ area é¢ç§¯çæ¨ªåè¿æ¥çº¿ç px ä½ç½®
 * @param data
 * @param width
 * @param height
 */
export function getAreaLineY(data, height) {
    var y = new Linear({
        values: data,
    });
    // å½æ²çº¿å¨é¨ä¸ºè´æ°æ¶ï¼åæå¤§å¼ï¼å½æ²çº¿å¨é¨ä¸ºæ­£æ°æ¶ï¼åæå°å¼ï¼å½æ²çº¿ææ­£æè´ï¼ååé¶ç¹
    var lineY = y.max < 0 ? y.max : Math.max(0, y.min);
    return height - y.scale(lineY) * height;
}
/**
 * çº¿ path è½¬ area path
 * @param path
 * @param width
 * @param height
 */
export function linePathToAreaPath(path, width, height, data) {
    var areaPath = __spreadArrays(path);
    var lineYPx = getAreaLineY(data, height);
    areaPath.push(['L', width, lineYPx]);
    areaPath.push(['L', 0, lineYPx]);
    areaPath.push(['Z']);
    return areaPath;
}
//# sourceMappingURL=path.js.map